import { Component } from "@/decorators";
import CorModel from "@/models/corModel";
import corService from "@/services/corService";

import EditComponentBase from "../editComponentBase";

@Component
export default class CorEditComponent extends EditComponentBase<CorModel> {
    private async beforeMount() {
        await this.setPropsCached(corService, "cores", new CorModel());
    }
}
